import axios from 'axios';
import { setIsRequestProcessing } from "./ccf-copilot-chat/+state/ccf-live-copilot.slice";
import { setGeneratedEmailResponse, setIsCopilotEmailResponseGenerated } from '@nice-ccf/ui-components';
import { processApiResponse } from './ccf-copilot-util';
import { $getRoot, $getSelection } from 'lexical';

export interface ApiResponse {
    agentAssistSource: string;
    contactId: string;
    utcTimestamp: string;
    acpAppElements: {
      cardType: string;
      contentType: string;
      content: string;
      objectId: string;
    }[];
  }

  const API_ENVIRONMENTS = {
    PRODUCTION: 'd37o4fq4eh0r63.cloudfront.net',
    STAGING: 'd2s0hs7fbnng2d.cloudfront.net',
    LOCALHOST: 'localhost',
  };
  const PROD_API_BASE_URL ='https://1tx1doz6q5.execute-api.us-west-2.amazonaws.com/dev/agentcopilotapi/v1';
  const STAGE_API_BASE_URL ='https://1tx1doz6q5.execute-api.us-west-2.amazonaws.com/test/agentcopilotapi/v1';
  export let API_BASE_URL: string;

  switch (window.location.hostname) {
    case API_ENVIRONMENTS.PRODUCTION:
      API_BASE_URL = PROD_API_BASE_URL;
      break;
    case API_ENVIRONMENTS.STAGING:
    case API_ENVIRONMENTS.LOCALHOST:
      API_BASE_URL = STAGE_API_BASE_URL;   // edit here to change the API URL for environment specific API testing after backend deployment
      break;
    default:
      API_BASE_URL = STAGE_API_BASE_URL;
      break;
  }
  export const TRANSCRIPTION =  '/transcription';
  export const PROCESS_UTTERANCE =  '/process-utterance';
  export const PERSONA = '/persona';
  export const AGENT_SEARCH = '/agent-search';
  export const EXPERT = '/expert';
  export const JOURNEY_SUMMARY = '/journey-summary';
  export const FINAL_SUMMARY = '/final-summary';
  export const EMAIL = '/email';
  export const GENERATE_EMAIL = '/generate-email';
  export const TOPICS = '/topics';
  export const ACTION = '/action';
  export const EXPERT_VERTICALS = '/KbConfig/expert-verticals';
  export const EXPERT_CREATE = '/KbConfig/expert/create';
  export const EXPERT_UPDATE = '/KbConfig/expert/update';
  export const EXPERT_CONVERSATIONS = '/KbConfig/expert/conversations/files';
  export const DOWNLOAD_CONVERSATION_FILES = '/KbConfig/conversation-file';
  export const AGENT_CONNECTION ='/agent-connection';
  export const RENAME_CONVERSATION_FILE = '/KbConfig/expert/conversations/rename';
  export const TEST_EXPERT = '/expert/ask-question';
  export const ADMIN_ACCESS = '/admin-access';
  export const UPDATE_ADMIN_ACCESS = '/admin-access/update';
  export const UPADATE_DEMO_STATUS = '/KbConfig/expert/update/status';
  export const UPDATE_FILE_STATUS = '/KbConfig/expert/update/associated-file-status';

  export const AUTHORIZATION_TOKEN = 'Basic YWdlbnRjb3BpbG90YWRtaW46bmljZTJoYXZleW91IzIwMjQ=';
  
  /**
   * to invoke API's
   * @param url - request url
   * @param method - method type
   * @param requestBody - request body
   * @example - `callApi(url, method, requestBody)`
   */
  export function callApi(
    url: string,
    method: string,
    body?: any,
    dispatch?: any,
    agentSearch? : boolean
  ): Promise<ApiResponse> {
    return new Promise<ApiResponse>((resolve, reject) => {
      if(body?.participantId === 'patron' || agentSearch === true){
      dispatch(setIsRequestProcessing(true));
      }
      fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json',
          Authorization: AUTHORIZATION_TOKEN,
        },
        body: JSON.stringify(body),
      })
        .then((response) => {
          if (response.status === 204) {
            // Handle 204 response here, for example:
            //dispatch(setIsRequestProcessing(false));
            return Promise.resolve() as unknown as Promise<ApiResponse>;
        } else {
            return response.json() as Promise<ApiResponse>;
        }
        })
        .then((data) => {
          if (data) {
            // dispatch(setIsRequestProcessing(false));
            resolve(data);
          } else {
            resolve({} as ApiResponse);
          }
        })
        .catch((error) => {
          // dispatch(setIsRequestProcessing(false));
          reject(error);
        });
    });
  }
  
  /**
   * to invoke API's
   * @param message - message
   * @param fromEntity - fromEntity
   * @example - `fetchConversationAssistance(message,fromEntity)`
   */
  export function fetchConversationAssistance(
    messageEntities: Array<{message: string, fromEntity: string}>,
  ): Promise<any> {
    const conversationChat = messageEntities.map(({ message, fromEntity }) => {
      return fromEntity === 'patron' ? `Customer said: ${message}` : `Agent said: ${message}`;
    }).join('\n');
  
    return new Promise<any>((resolve, reject) => {
      fetch(API_BASE_URL + EXPERT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: AUTHORIZATION_TOKEN,
        },
        body: JSON.stringify({
          // eslint-disable-next-line no-useless-escape
          Chats: `Below  is a customer service chat. What questions does the customer have so far? One question per object.  Use this JSON format as your output.\"\n{\n\"CustomerQuestionsAndConcerns\":[{\n\"customerConcern\":,\n\"customerQuestionOrStatement\":,\n\"IsConcernResolvedByAgent\":,\n\"CSVStepsFollowedByAgent\":\n}\n]\n}\n\nChat:\n${conversationChat}`,
          Question: "",
          ModelType: ""
        }),
      })
        .then((response) => {
          return response.json() as Promise<any>;
        })
        .then((data) => resolve(data))
        .catch((error) => reject(error));
    });
  }

  /**
   * to invoke API's
   * @param activeContact - id
   * @param userReplyChatData - email content
   * @example - `fetchEmailTopics(activeContact, userReplyChatData, dispatch)`
   */
  export const fetchEmailTopics = async (
    contactId: any,
    userReplyChatData: any,
    dispatch: any
  ) => {
    const url = API_BASE_URL + EMAIL + TOPICS;
    const utcTimestamp = new Date().toISOString();
    const objectIdPrefix = 'e15d4e75-39fa-4f9d-85a1-daffe6d16a40_';
    const contentType = 'emailResponseSuggestedLive';
    const objectId = objectIdPrefix + contentType;
  
    try {
      const requestBody = {
        contactId,
        maxTopics: 3,
        language: 'en-US',
        emailBody: userReplyChatData,
      };
  
      const responseData = await axios.post(
        url,
        requestBody,
        {
          headers: {
            "Authorization": AUTHORIZATION_TOKEN,
            "Content-Type": "application/json-patch+json",
            "Accept": "text/plain",
          }
        }
      );
  
      const fetchedEmailTopics = responseData.data.topics;
  
      const updatedEmailTopics = fetchedEmailTopics.map((topic: any, index: number) => ({
        content: topic.content,
        sentiment: topic.sentiment,
        topicId: topic.topicId,
      }));

      const selectedTopicId = fetchedEmailTopics
        .map((topic: any) => topic.topicId)
        .join(',');
  
      const content = JSON.stringify({
        subtitle: responseData.data.subtitle,
        generationTitle: responseData.data.generationTitle,
        generationDescription: responseData.data.generationDescription,
        emailTopics: updatedEmailTopics,
        selectedTopicId: selectedTopicId,
      });
  
      const apiResponse = {
        agentAssistSource: 'Illuminate',
        contactId,
        utcTimestamp,
        acpAppElements: [
          {
            cardType: 'AdaptiveCard',
            contentType,
            content,
            objectId,
          },
        ],
        type: null,
      } as ApiResponse;
  
      dispatch(setIsRequestProcessing(true));
      setTimeout(() => {
        dispatch(setIsRequestProcessing(false));
        processApiResponse(apiResponse, dispatch);
      }, 2000);
  
    } catch (error) {
      console.error("Error fetching email topics:", error);
    }
  };

  /**
    * Used to get the draft email by contactId and uniqueEmailId
    * @param contactId - contact Id
    * @param emailIdentifier - unique email Id
    * @param topics - list of topics
    * @example - 
    * ``` 
    * copilotService.generateEmail('12321', 'uniqueEmailId', [{topicId: '123', content: 'topicName'}]);
    * ```
    */
  export const generateEmail = async (
    contactId: string,
    topics: {
      sentiment?: any;
      topicId: string;
      content: string;
    }[],
    dispatch: any,
    copilotConfigurations: any
  ) => {
    dispatch(setIsRequestProcessing(true));
    try {
      const url = API_BASE_URL + EMAIL + GENERATE_EMAIL;
      const requestBody = {
        generateEmailMetadata: topics.map((topic) => ({
          topic: topic.content,
          sentiment: 'neutral',
          answers: 'string',
        })),
        contactId,
        tenantId: 12345678,
        expertUrl: copilotConfigurations?.expertCopilotURL ?? '',
        path: copilotConfigurations?.path ?? '',
        expertThreshold: copilotConfigurations?.threshold ?? 0.75,
        persona: copilotConfigurations?.botPersona ?? '',
        maxCompletionLength: 100,
      };

      const response = await axios.post(
        url,
        requestBody,
        {
          headers: {
            "Authorization": AUTHORIZATION_TOKEN,
            "Content-Type": "application/json-patch+json",
            "Accept": "text/plain",
          }
        }
    );

      if (response.data) {
        dispatch(setGeneratedEmailResponse(response.data));
        dispatch(setIsCopilotEmailResponseGenerated(true));
        dispatch(setIsRequestProcessing(false));
      } else {
        setIsCopilotEmailResponseGenerated(false);
        throw new Error('Failed to generate email');
      }
    } catch (error) {
      console.error('Error generating email:', error);
    } finally {
      dispatch(setIsRequestProcessing(false));
    }
  };

  /**
   * Handles the text selection in the editor.
   * @example simplifyText(selectedText)
   */
  export const simplifyText = async (
    selectedText: string,
    editorRef: React.RefObject<any>
  ) => {
    let emailBody = '';
    if (editorRef.current) {
      editorRef.current.update(() => {
        emailBody = $getRoot().getTextContent();
      });
    } else {
      throw new Error('Editor reference is null');
    }
    const requestBody = {
      emailBody,
      action: 'simplify',
      selectedText: selectedText,
    };
  
    try {
      const url = API_BASE_URL + EMAIL + ACTION;
      const response = await axios.post(url, requestBody, {
        headers: {
          Authorization: AUTHORIZATION_TOKEN,
          'Content-Type': 'application/json-patch+json',
          Accept: 'text/plain',
        },
      });
      return response;
    } catch (error) {
      console.error('Error simplifying text:', error);
    }

    return null;
  };